(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-gradient"] && !Shopify.designMode) return;
  try {
    
  /* Flechas del carrusel mobile de "Details you'll fall for". Solo agrega
     dos botones al lado de la fila y hace scroll por columna; el layout es
     100% CSS (ver stylesheet de esta seccion). */
  (function () {
    const PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="14.5 5 7.5 12 14.5 19"></polyline></svg>';
    const NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9.5 5 16.5 12 9.5 19"></polyline></svg>';

    function setup() {
      document.querySelectorAll('[id$="__detalles"] .layout-panel-flex--row').forEach((row) => {
        if (row.querySelector(':scope > .group-block')) return;
        if (!row.querySelector(':scope > .image-block')) return;
        const wrap = row.parentElement;
        if (!wrap || wrap.dataset.serDet === '1') return;
        wrap.dataset.serDet = '1';
        wrap.classList.add('ser-det-wrap');

        const mk = (dir, svg, cls) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ser-det-arrow ' + cls;
          b.setAttribute('aria-label', dir < 0 ? 'Previous' : 'Next');
          b.innerHTML = svg;
          b.addEventListener('click', () => {
            const first = row.querySelector(':scope > .image-block');
            const step = first ? first.getBoundingClientRect().width + 12 : row.clientWidth * 0.82;
            row.scrollBy({ left: dir * step, behavior: 'smooth' });
          });
          return b;
        };
        const prev = mk(-1, PREV, 'ser-det-arrow--prev');
        const next = mk(1, NEXT, 'ser-det-arrow--next');
        wrap.appendChild(prev);
        wrap.appendChild(next);

        const update = () => {
          const first = row.querySelector(':scope > .image-block');
          if (first) wrap.style.setProperty('--ser-det-arrow-top', (first.offsetTop + first.offsetHeight / 2) + 'px');
          const max = row.scrollWidth - row.clientWidth - 2;
          prev.disabled = row.scrollLeft <= 2;
          next.disabled = row.scrollLeft >= max;
        };
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        const img = row.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', update);
        update();
        setTimeout(update, 600);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlights-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('highlights-bar')) {
    class HighlightsBar extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.shb__item'));
        this.index = 0;
        this.timer = null;
        this.mq = window.matchMedia('(max-width: 749px)');

        this.querySelectorAll('.shb__arrow').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.go(parseInt(btn.dataset.dir, 10) || 1);
            this.restart();
          });
        });

        let startX = null;
        this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) { this.go(dx < 0 ? 1 : -1); this.restart(); }
          startX = null;
        }, { passive: true });

        this.onVisibility = () => { document.hidden ? this.stop() : this.start(); };
        document.addEventListener('visibilitychange', this.onVisibility);

        this.onMq = () => { this.mq.matches ? this.start() : this.stop(); };
        this.mq.addEventListener('change', this.onMq);
        this.onMq();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.mq.removeEventListener('change', this.onMq);
      }

      go(dir) {
        if (this.items.length < 2) return;
        const prev = this.items[this.index];
        this.index = (this.index + dir + this.items.length) % this.items.length;
        const next = this.items[this.index];
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        setTimeout(() => prev.classList.remove('is-leaving'), 400);
        next.classList.add('is-active');
      }

      start() {
        if (this.dataset.autoplay !== 'true' || !this.mq.matches || this.items.length < 2) return;
        this.stop();
        const ms = Math.max(2000, parseInt(this.dataset.interval, 10) || 4000);
        this.timer = setInterval(() => this.go(1), ms);
      }

      stop() {
        if (this.timer) { clearInterval(this.timer); this.timer = null; }
      }

      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('highlights-bar', HighlightsBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
